import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  matchPath,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";
import HospitalStepProtectedRoute from "./components/admin/Auth/hospitalProtect";
import NavBar from "./components/admin/web/navBar";
import Home from "./components/admin/web/home";
import About from "./components/admin/web/about";
import Patient from "./components/admin/web/patient";
import Nurse from "./components/admin/web/nurse";
import Physio from "./components/admin/web/physio";
import Install from "./components/admin/web/install";
import Footer from "./components/admin/web/footer";
import Contact from "./components/admin/web/contact";
import Download from "./components/admin/web/download";
import Terms from "./components/admin/web/toc/terms";
import Privacy from "./components/admin/web/toc/privacyPolicy";
import DeleteAccount from "./components/admin/web/toc/deletemyaccount";
import Partner from "./components/admin/web/partner/partner";
import Login from "./components/admin/UnAuth/login";
import MainLayout from "./components/admin/Auth/MainLayout";
import Dashboard from "./components/admin/Auth/pages/dashboard";
import UserAcquisition from "./components/admin/Auth/pages/userAque";
import UserEngagement from "./components/admin/Auth/pages/engagement";
import Monetization from "./components/admin/Auth/pages/monetization";
import Payment from "./components/admin/Auth/pages/payment";
import User from "./components/admin/Auth/pages/user";
import Booking from "./components/admin/Auth/pages/booking";
import Account from "./components/admin/Auth/pages/account";
import Support from "./components/admin/Auth/pages/support";
import BookingsProfile from "./components/admin/Auth/profileDetails/bookingsProfile";
import Profile from "./components/admin/Auth/profileDetails/profile";
import ProtectedRoute from "./components/admin/Auth/ProtectedRoute";
import Visits from "./components/admin/Auth/pages/checkVisits";
import Notification from "./components/admin/Auth/pages/notificationCenter";
import Hospital from "./components/admin/Auth/adminPartner/partnerList";
import AddHospital from "./components/admin/Auth/adminPartner/partnerEdit";
import HospitalProfile from "./components/admin/Auth/adminPartner/partnerView";
import PartnerListMobile from "./components/admin/Auth/adminPartner/mobile/partnerListMobile";
import PartnerViewMobile from "./components/admin/Auth/adminPartner/mobile/partnerViewMobile";
import Leads from "./components/admin/Auth/pages/leads";
import MCT from "./components/admin/Auth/common/manageCT";
import HospitalLogin from "./components/admin/UnAuth/partnerLogin";
import RoleProtectedRoute from "./components/admin/Auth/roleProtectRoute";
import { IoIosArrowDropup } from "react-icons/io";
import NotFound from "./components/admin/Auth/notfound";
import Agreement from "./components/admin/Auth/adminPartner/agreement";
import Membership from "./components/admin/Auth/adminPartner/membership";
import RateFix from "./components/admin/Auth/adminPartner/rateFix";
import StaffSheduling from "./components/admin/Auth/adminPartner/staffShedule";
import BankDetails from "./components/admin/Auth/adminPartner/bankDetails";
import { Rate } from "antd";
import MCTProtectedRoute from "./components/admin/Auth/hospitalProtect";
import EditHospital from "./components/admin/Auth/adminPartner/editProfile";
import Enquiry from "./components/admin/web/partner/enquiry";
import Role from "./components/admin/web/partner/roleSelect";
import EnquiryList from "./components/admin/Auth/pages/enquirylist";
import ManageAccess from "./components/admin/Auth/pages/manageAccess";
import PaymentRedirect from "./components/admin/web/toc/verificationRedirect";
import DevPaymentRedirect from "./components/admin/web/toc/devVerificationRedirect";
import { ToastContainer } from "react-toastify";
import BlockedNumbers from "./components/admin/Auth/pages/blockedNumbers";
import ApiLogs from "./components/admin/Auth/pages/apiLogs";
import "react-toastify/dist/ReactToastify.css";
import PartnerProfile from "./components/admin/Auth/partnerPortal/partnerProfile";
// import ManageDuty from "./components/admin/Auth/partnerPortal/manageDuty";
import Pricing from "./components/admin/Auth/partnerPortal/pricing";
import HelpAdmin from "./components/admin/Auth/partnerPortal/helpAdmin";
import Payouts from "./components/admin/Auth/common/payouts";
import PartnerVisits from "./components/admin/Auth/common/visits";
import PartnerDashboard from "./components/admin/Auth/partnerPortal/partnerDashboard";
import Branches from "./components/admin/Auth/common/branches";
import Billings from "./components/admin/Auth/partnerPortal/billings";
import PatientsBooking from "./components/admin/Auth/common/patientsBooking";
import PatientList from "./components/admin/Auth/partnerPortal/booking";

const App = () => {
  const showNavBarRoutes = [
    "/",
    "/about",
    "/patient",
    "/nurse",
    "/physio",
    "/app",
  ];

  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const shouldShowNavBar = showNavBarRoutes.includes(location.pathname);

  const refresh = secureLocalStorage.getItem("isAuth") === true;

  const [showScrollTop, setShowScrollTop] = useState(false);
  const role = secureLocalStorage.getItem("role");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleScroll = () => {
    setShowScrollTop(window.scrollY > 300);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setSearchTerm("");
  }, [location.pathname]);

  return (
    <div className="scroll-smooth">
      <ToastContainer />
      {shouldShowNavBar && <NavBar />}
      <Routes>
        <Route
          path="/"
          element={
            <div className="overflow-x-hidden ">
              <section
                id="home"
                className="min-h-[80vh] w-full max-w-screen bg-[#fff] flex justify-center items-center px-4 md:px-8"
              >
                <Home />
              </section>
              <section
                id="about"
                className="min-h-[100vh] lg:min-h-[80vh]  w-full max-w-screen bg-[#fff] flex items-start"
              >
                <About />
              </section>
              <section
                id="patient"
                className="min-h-screen w-full max-w-screen bg-[#E9E9F44D] flex justify-center items-center"
              >
                <Patient />
              </section>
              <section
                id="nurse"
                className="min-h-screen w-full max-w-screen bg-white flex flex-col items-center"
              >
                <Nurse />
              </section>
              <section
                id="physio"
                className="min-h-screen w-full max-w-screen bg-white flex justify-center items-center"
              >
                <Physio />
              </section>
              <section
                id="contact"
                className="min-h-screen w-full max-w-screen bg-white flex justify-center items-start"
              >
                <Contact />
              </section>
              <section
                id="app"
                className="min-h-2/4 w-full max-w-screen bg-white flex justify-center items-start"
              >
                <Install />
              </section>
              <section
                id="footer"
                className="min-h-2/4 w-full max-w-screen bg-white flex justify-center items-start"
              >
                <Footer />
              </section>
            </div>
          }
        />
        <Route path="/deletemyaccount" element={<DeleteAccount />} />
        <Route path="/verify" element={<PaymentRedirect />} />
        <Route path="/devverify" element={<DevPaymentRedirect />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/enquiries" element={<Enquiry />} />
        <Route path="/roleSelection" element={<Role />} />

        <Route path="/download" element={<Download />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacyPolicy" element={<Privacy />} />

        <Route path="/contract" element={<Agreement />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/ratefix" element={<RateFix />} />
        <Route path="/bankdetails" element={<BankDetails />} />

        {!refresh && <Route path="/admin/login" element={<Login />} />}
        {!refresh && (
          <Route path="/partner/login" element={<HospitalLogin />} />
        )}
        {/* Mobile partner monitor — full-screen, no admin sidebar/topbar shell.
            Open directly via /admin/partnerlistMobile (auth-protected). */}
        <Route
          path="/admin/partnerlistMobile"
          element={
            <ProtectedRoute>
              <PartnerListMobile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/partnerMobile"
          element={
            <ProtectedRoute>
              <PartnerViewMobile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </ProtectedRoute>
          }
        >
          <Route element={<RoleProtectedRoute allowedRoles={["super user"]} />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/userAque" element={<UserAcquisition />} />
            <Route path="/admin/engagement" element={<UserEngagement />} />
            <Route path="/admin/monetization" element={<Monetization />} />
            <Route path="/admin/payment" element={<Payment />} />
            <Route path="/admin/leads" element={<Leads />} />
            <Route
              path="/admin/account"
              element={<Account searchTerm={searchTerm} />}
            />
            <Route path="/admin/visits" element={<Visits searchTerm={searchTerm} />} />
            <Route
              path="/admin/enquirylist"
              element={<EnquiryList searchTerm={searchTerm} />}
            />
            <Route path="/admin/access" element={<ManageAccess />} />
            <Route path="/admin/blockedNumbers" element={<BlockedNumbers />} />
            <Route path="/admin/api-logs" element={<ApiLogs />} />
            {/* <Route
              path="partnerVerification"
              element={<PartnerVerification />}
            /> */}
          </Route>
          <Route
            element={
              <RoleProtectedRoute
                allowedRoles={["super user", "relationship manager"]}
              />
            }
          >
            <Route path="/admin/booking" element={<Booking />} />
            <Route path="/admin/user" element={<User searchTerm={searchTerm} />} />
            <Route path="/admin/notification" element={<Notification />} />
          </Route>
          <Route
            element={
              <RoleProtectedRoute allowedRoles={["super user", "support"]} />
            }
          >
            <Route path="/admin/support" element={<Support />} />
          </Route>
          <Route element={<RoleProtectedRoute allowedRoles={["hospital"]} />}>
            <Route
              path="/partner/careteam"
              element={
                // <MCTProtectedRoute>
                <MCT searchTerm={searchTerm} />
                // </MCTProtectedRoute>
              }
            />
            <Route path="/partner/staffsheduling" element={<StaffSheduling />} />
            <Route path="/partner/profile" element={<PartnerProfile />} />
            <Route path="/partner/helpAdmin" element={<HelpAdmin />} />
            {/* <Route path="/partner/manageduty" element={<ManageDuty />} /> */}
            <Route path="/partner/pricing" element={<Pricing />} />
            <Route path="/partner/payouts" element={<Payouts />} />
            <Route path="/partner/visits" element={<PartnerVisits searchTerm={searchTerm} />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/partner/branches" element={<Branches />} />
            <Route path="/partner/billings" element={<Billings />} />
            <Route path="/partner/patients" element={<PatientsBooking searchTerm={searchTerm} />} />
            <Route path="/partner/bookings" element={<PatientList searchTerm={searchTerm} />} />
          </Route>

          <Route path="/admin/profile/:index" element={<Profile />} />
          <Route path="/admin/bookingsProfile/:index" element={<BookingsProfile />} />
          <Route
            path="/admin/partnerlist"
            element={<Hospital searchTerm={searchTerm} />}
          />
          <Route path="/admin/partnerEdit" element={<AddHospital />} />
          <Route path="/admin/hospitalProfile" element={<HospitalProfile searchTerm={searchTerm} />} />
          <Route path="/admin/EdithospitalProfile" element={<EditHospital />} />
          <Route
            path="*"
            element={
              <Navigate
                to={role !== "hospital" ? "/admin/dashboard" : "/partner/careteam"}
              />
            }
          />
          {/* // <Route path="*" element={<NotFound />} /> */}
        </Route>
      </Routes>
    </div>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
